import { IProduct } from 'interfaces/products';
import axios, { Response } from 'services';

export interface IProductSResponse {
	items: IProduct[];
	status: string;
};
export const getPartnersData = (): Response<IProductSResponse> => {
	return axios.get(`/partners`);
};

export const getPartnerDataById = (id: string): Response<IProduct> => {
	return axios.get(`/partners/${id}`);
};
